<template>
  <div class="card">
    <div class="card-body pb-0">
      <span class="badge bg-dark">{{'Assignment' | translate}}</span>
    </div>
    <div class="card-body">
      <div v-html="component.data.assignment.html"></div>
      <div v-if="component.data.assignment_img">
        <img
          :src="imageUrl(component.data.assignment_img)"
          alt=""
          class="img-fluid"
        />
      </div>
      <div>
        <button class="btn btn-primary btn-sm fw-bold" @click="toggleSolution">
          {{ 'Solution' | translate }}
        </button>
        <transition name="component-fade" mode="out-in">
          <div v-if="showSolution" key="1">
            <div class="mt-4" v-html="component.data.solution.html"></div>
            <div class="mt-4" v-if="component.data.solution_img">
              <img
                :src="imageUrl(component.data.solution_img)"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component'],
  data: () => ({
    showSolution: false,
  }),
  methods: {
    toggleSolution() {
      this.showSolution = !this.showSolution
    },
    imageUrl(url) {
      if (url) {
        return `${document.location.protocol}//djceg34j53tq.cloudfront.net/${url}`
      }
      return ''
    },
  },
}
</script>
